import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      padding: 0
    },
    closeDialog: {
      cursor: "pointer"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 860,
        borderRadius: 16,
        marginTop: 50,
        padding: "32px 24px"
      },
      "& .MuiDialogContent-root": {
        padding: 0,
        margin: "32px 0"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        display: "flex",
        justifyContent: "space-between",
        gap: "0 16px",
        padding: 0
      },
      "& *": {
        fontFamily: "ScgFont, sans-serif",
        letterSpacing: 0
      }
    },

    dialogContent: {
      maxHeight: "calc(100% - 64px)",
      overflow: "auto"
    },
    rootTable: {
      borderRadius: 0,
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,

      "& .MuiTableCell-root": {
        padding: "1.2rem 1.2rem ",
        color: theme.palette.grey[900]
      },
      "& .MuiTableCell-head": {
        color: theme.palette.grey[900]
      },
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    },
    col56: {
      minWidth: 56,
      color: theme.palette.grey[900]
    },
    col140: {
      minWidth: 140,
      color: theme.palette.grey[900]
    },
    col190: {
      minWidth: 190,
      color: theme.palette.grey[900]
    },
    col135: {
      width: 135,
      color: theme.palette.grey[900]
    },
    col156: {
      width: 156,
      color: theme.palette.grey[900]
    },
    estDateMatch: {
      color: theme.palette.info.dark,
      "& .MuiTypography-root": {
        color: theme.palette.info.dark
      }
    },
    estDateNotMatch: {
      color: `${theme.palette.error.light} !important`
    },
    title: {
      color: theme.palette.info.main,
      fontSize: 20,
      display: "inline-block"
    },
    buttonAction: {
      flex: 1
    },
    colHead: {
      "& .MuiTypography-root": {
        fontSize: 12
      }
    }
  }),
  { name: "NotMatchModal" }
);

export default useStyles;
